import React, { useState, useEffect, useCallback } from "react";
import { TOUR_STEPS } from "./CompareHelpContent";
import "./CompareTour.css";

const CompareTour = ({ open, onClose }) => {
  const [stepIdx, setStepIdx] = useState(0);
  const [targetRect, setTargetRect] = useState(null);

  const step = TOUR_STEPS[stepIdx];

  const updatePosition = useCallback(() => {
    if (!open || !step) return;
    const el = document.querySelector(step.selector);
    if (!el) {
      setTargetRect(null);
      return;
    }
    el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    setTargetRect(el.getBoundingClientRect());
  }, [open, step]);

  useEffect(() => {
    if (open) {
      setStepIdx(0);
    }
  }, [open]);

  useEffect(() => {
    updatePosition();
  }, [stepIdx, updatePosition]);

  useEffect(() => {
    if (!open) return;
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);
    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [open, updatePosition]);

  if (!open || !step) return null;

  const isLast = stepIdx === TOUR_STEPS.length - 1;
  const isFirst = stepIdx === 0;

  let popoverStyle = {};
  if (targetRect) {
    const popoverWidth = 320;
    const popoverHeight = 180;
    const margin = 12;

    let top = targetRect.bottom + margin;
    let left = targetRect.left + targetRect.width / 2 - popoverWidth / 2;

    if (top + popoverHeight > window.innerHeight - margin) {
      top = targetRect.top - popoverHeight - margin;
    }
    if (top < margin) {
      top = margin;
    }
    if (left + popoverWidth > window.innerWidth - margin) {
      left = window.innerWidth - popoverWidth - margin;
    }
    if (left < margin) {
      left = margin;
    }

    popoverStyle = { top, left, width: popoverWidth };
  } else {
    popoverStyle = {
      top: window.innerHeight / 2 - 90,
      left: window.innerWidth / 2 - 160,
      width: 320,
    };
  }

  const highlightStyle = targetRect
    ? {
        top: targetRect.top - 4,
        left: targetRect.left - 4,
        width: targetRect.width + 8,
        height: targetRect.height + 8,
      }
    : { display: "none" };

  return (
    <div className="ct-overlay">
      <div className="ct-highlight" style={highlightStyle} />
      <div className="ct-popover" style={popoverStyle}>
        <div className="ct-popover-header">
          <span className="ct-step-badge">{stepIdx + 1} / {TOUR_STEPS.length}</span>
          <span className="ct-title">{step.title}</span>
        </div>
        <div className="ct-body">{step.body}</div>
        <div className="ct-footer">
          <button className="ct-btn ct-btn--skip" onClick={onClose}>
            Skip
          </button>
          <div className="ct-nav">
            {!isFirst && (
              <button
                className="ct-btn ct-btn--prev"
                onClick={() => setStepIdx(stepIdx - 1)}
              >
                ← Back
              </button>
            )}
            <button
              className="ct-btn ct-btn--next"
              onClick={() => {
                if (isLast) {
                  onClose();
                } else {
                  setStepIdx(stepIdx + 1);
                }
              }}
            >
              {isLast ? "Done" : "Next →"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompareTour;
